import React from 'react';
import { Link } from 'react-router-dom';
import './worksCard.css';
import {projects} from '../../Data/Projects';
import GridViewIcon from '@mui/icons-material/GridView';
import ListIcon from '@mui/icons-material/List';
import { useGridView } from '../GridViewContext';

function WorksCard({ showAll }) {
    // const [isGridView, setIsGridView] = useState(false);
    const { isGridView, toggleView } = useGridView();
    const projectsToDisplay = showAll ? projects : projects.slice(0, 4);
    const gridProjectDisplay = showAll ? projects : projects.slice(0, 2);    

  return (
    <>
        <div className="projects-container">
            <div className="view-btns-div">
                <div className="view-btn list" onClick={toggleView} style={isGridView ? { backgroundColor: 'transparent' } : { backgroundColor: '#455CE9', color: 'white', border: '1px solid #455CE9', pointerEvents: 'none' }}>
                    <div className="view-btn-hover"></div>
                    <ListIcon sx={{ fontSize: `calc(clamp(4.25em, 7vw, 8em) * .38)`, zIndex: 1 }} />
                </div>
                <div className="view-btn grid" onClick={toggleView} style={isGridView ? { backgroundColor: '#455CE9', color: 'white', border: '1px solid #455CE9', pointerEvents: 'none' } : { backgroundColor: 'transparent' }}>
                    <div className="view-btn-hover"></div>
                    <GridViewIcon sx={{ fontSize: `calc(clamp(4.25em, 7vw, 8em) * .38)`, zIndex: 1 }} />
                </div>
            </div>
            {isGridView ? (
                <div className="square-view">
                    <ul className="square-view-container">
                    {gridProjectDisplay.map(project => (
                        <li key={project.title} >
                            <Link to={`/work/${project.title}`}>
                                <div className="square-padding">
                                    <div className="square">
                                        <div className="square-top">
                                            <div className="square-img">
                                                <div className="color-overlay">
                                                    <img src={project.cover} alt="" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="square-bot">
                                            <h3>{project.title}</h3>
                                            <hr />
                                            <div className="project-data">
                                                <div className="square-type">
                                                    {project.type}
                                                </div>
                                                <div className="square-year">
                                                    {project.year}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Link>
                        </li>
                        ))}
                    </ul>
                </div>
            ) : (
                <div className="list-view">
                    {projectsToDisplay.map(project => (
                        <div className="project-card" key={project.title}>
                            <Link to={`/work/${project.title}`}>
                                <div className="project-box">
                                    <div className="project-titl">
                                        {project.title}
                                    </div>
                                    <div className="project-type">
                                        {project.type}
                                    </div>
                                </div>
                            </Link>
                        </div>
                    ))}
                </div>
            )}
            {!showAll && (
            <div className="more-works">
                <Link to='/work'>
                    <div className="more-works-btn">
                        <div className="more-works-btn-hover"></div>
                        <h4 className='more-works-btn-titl'>More Works</h4>
                    </div>
                </Link>
            </div>
            )}
        </div>
    </>
  );
}

export default WorksCard